<template>
  <v-timeline-item
    :color="new Date(step.$.startDate) < new Date() ? 'success' : 'primary'"
    :icon="icon"
    fill-dot
  >
    <v-list-item
      v-bind="listItemProps"
      class="trip-step"
      :three-line="!!step.$.location"
    >
      <v-list-item-avatar class="align-self-center">
        {{ step.$.startDate | fmtDate('D MMM') }}
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{ step.$.name }}</v-list-item-title>
        <v-list-item-subtitle v-if="step.$.location">
          <v-icon small>
            mdi-map-marker
          </v-icon>
          {{ step.$.location }}
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action class="align-self-center">
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn
              icon
              @click.stop.prevent="$listeners.click"
              v-on="on"
            >
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>

          <span v-text="'Edit'" />
        </v-tooltip>

        <div v-if="step.$.attachment">
          <v-btn
            icon
            :href="step.$.attachment"
            target="_blank"
            @click.stop
          >
            <v-icon>mdi-paperclip</v-icon>
          </v-btn>
        </div>
      </v-list-item-action>
    </v-list-item>
  </v-timeline-item>
</template>

<script>
import { distanceInWordsStrict } from 'date-fns'

import { getStepIcon } from '@/components/TripStepTypes'
import TripStep from '@/models/TripStep'

export default {
  props: {
    step: {
      type: TripStep,
      reuired: true,
      default: null
    }
  },
  computed: {
    icon () {
      return getStepIcon(this.step)
    },
    listItemProps () {
      if (this.step.$.url) {
        return {
          href: (this.step.$.url.includes('://') ? '' : 'https://') + this.step.$.url,
          target: '_blank'
        }
      } else {
        return {}
      }
    },
    stepDuration () {
      return distanceInWordsStrict(this.step.$.startDate, this.step.$.endDate, { unit: 'd' })
    }
  }
}
</script>

<style lang="scss">
.trip-step {
  border-radius: 32px !important;

  &::before, & > .v-ripple__container {
    border-radius: 32px !important;
  }

  &.v-list-item--three-line {
    border-radius: 58.6666666667px !important;

    &::before, & > .v-ripple__container {
      border-radius: 58.6666666667px !important;
    }
  }
}
</style>
